import React, { useEffect } from 'react'
import classes from './AdminContexts.module.css'
import { Button, Divider, Grid, Heading, Input } from '@chakra-ui/react'
import AdminContextsTable from './AdminContextsTable'
import { useAdminStore } from '../../store/adminStore'

function AdminContexts() {
    const [filters, setFilters] = useAdminStore(state => [state.contextsPageFilters, state.setContextsPageFilters])

    useEffect(() => {
        if (Object.keys(filters).length === 0)
            setFilters({
                only_without_contexts: true,
                email: null,
            })
    }, [])

    return (
        <Grid gap='var(--default-gap)'>
            <Grid className={classes.container}>
                <Heading as='h3' size='md' whiteSpace='nowrap'>
                    Изменение контекста пользователя
                </Heading>
                <Divider />
                <Button
                    size='sm'
                    variant='outline'
                    style={filters?.only_without_contexts ? { background: 'orange' } : {}}
                    onClick={() => setFilters({ ...filters, only_without_contexts: !filters.only_without_contexts })}
                >
                    Исполнители без контекстов
                </Button>
                <Input
                    size='sm'
                    placeholder='Поиск по email'
                    value={filters?.email || ''}
                    onChange={(e) => setFilters({ ...filters, email: e.target.value || null })}
                />
            </Grid>

            <AdminContextsTable />
        </Grid>
    )
}

export default AdminContexts
